import {put, takeLatest, call} from 'redux-saga/effects';
import * as settingsService from "../../../services/settingsService";
import {
    SET_SETTINGS,
    SET_SETTINGS_SUCCESS,
    SET_SETTINGS_ERROR,
}
    from "../../actions/settings"

function* setSettingsSaga(action) {
    try {
       const data  = yield call(settingsService.SetSettings,action.payload)
        
       yield put({
        type: SET_SETTINGS_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: SET_SETTINGS_ERROR,error: error.data
        })
    }
}


export function* setSettingsSagaWatcher() {
    yield takeLatest(SET_SETTINGS, setSettingsSaga)
}